<template>

  <div style="padding-top: 100px;">
    <div class="ps-blog ps-blog--masonry">
      <div class="container">
        <breadcrumb :dataList="breadcrumb"/>
      </div>
      <div class="container mt-5">
        <h1 class="ps-blog__title text-left">Bloq</h1>
        <div class="ps-blog__content">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4" v-for="b in blogs.slice(0,5)" :key="b.id">


              <BlogPost :blog="b"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {baseUrl, imagePath, imageWidePath} from "@/repositories/Repository";
import {getBlogs} from "@/repositories/GeneralDataRepository";
import BlogPost from "@/components/layout/BlogPost.vue";
import Breadcrumb from "@/components/layout/page/Breadcrumb.vue";

export default {
  name: "BlogListPage",
  components: {Breadcrumb, BlogPost},
  data() {
    return {
      blogs: [],

      baseDomain: baseUrl,
      imagePath: imagePath,
      imageWidePath: imageWidePath,
      breadcrumb:[
        {
          url: '/',
          text: 'Home'
        },
        {
          url: '/blog',
          extraClass: 'active',
          text: "Bloq"
        }
      ]
    }
  },
  methods: {
    async getBlogs() {

      await getBlogs().then(data => {
        this.blogs = data;
      })

    },

  },
  created() {
    this.getBlogs();
  },
}
</script>

<style scoped>

.ps-blog__title {
  color: #103178;
  text-align: center;
}
</style>